// extracted by mini-css-extract-plugin
export var bubble = "_i-0";
export var container = "_i-f";
export var contrastBorder = "_i-g";
export var greyOut = "_i-2";
export var initialsColor0 = "_i-3";
export var initialsColor1 = "_i-4";
export var initialsColor10 = "_i-d";
export var initialsColor11 = "_i-e";
export var initialsColor2 = "_i-5";
export var initialsColor3 = "_i-6";
export var initialsColor4 = "_i-7";
export var initialsColor5 = "_i-8";
export var initialsColor6 = "_i-9";
export var initialsColor7 = "_i-a";
export var initialsColor8 = "_i-b";
export var initialsColor9 = "_i-c";
export var initialsWrapper = "_i-1";
export var large = "_i-l";
export var medium = "_i-k";
export var mediumSmall = "_i-j";
export var mediumSmallMedium = "_i-o";
export var micro = "_i-h";
export var small = "_i-i";
export var tiny = "_i-n";
export var xTiny = "_i-m";